export const DATE_PORTION = {
  BY_MINUTE: 'minute',
  BY_HOUR: 'hour',
  BY_DAY: 'dayOfMonth',
  BY_WEEK: 'week',
  BY_MONTH: 'month',
  BY_QUARTER: 'quarter',
  BY_YEAR: 'year',
};

export const OPERATION = {
  SUM: 'sum',
  COUNT: 'count',
  LAST: 'last',
  AVG: 'avg',
  MIN: 'min',
  MAX: 'max',
  FIRST: 'first',
  LAST: 'last',
  SIZE: 'size',
};

export const SORTING = {
  ASC: 'asc',
  DESC: 'desc',
};

export const POST_FIELDS = {
  CHANNEL: 'channel',
  POSTED_AT: 'postedAt',
  LIKES: 'likes',
  COMMENTS: 'comments',
  INTERACTIONS: 'interactions',
  SHARES: 'shares',
  POLARITY: 'polarity',
  DEVICE: 'device',
  TAG: 'tag',
  THEME: 'theme',
  GROUP: 'group',
  VIEWS: 'views',
  POST_TYPE: 'postType',
  GENDER: 'gender',
  IMPRESSIONS: 'impressions',
  REACH: 'reach',
  SAC_TYPE: 'sacType',
  SAC_STATUS: 'sacStatus',
  USER_ID: 'uid',
  OPERATOR: 'operator',
  POST_ID: 'pid',
  FB_VIEWS: 'fbViews',
  RATING: 'rating',
  ROUTING_ID: 'routingId',
};

export const USERS_FIELDS = {
  FOLLOWERS: 'followers',
  DATE: 'metricDate',
  CHANNEL: 'channel',
  UID: 'uid',
  USERNAME: 'username',
};

export const SAC_STATUS_FIELDS = {
  userId: 'userId',
  userName: 'username',
  pageId: 'pageId',
  channel: 'channel',
  status: 'value',
  lastStatus: 'lastValue',
  statusChangeTime: 'statusChangeTime',
  annotateAtDate: 'annotateAtDate',
};

export const POST_FIELDS_TYPE = {
  [POST_FIELDS.CHANNEL]: 'discrete',
  [POST_FIELDS.POSTED_AT]: 'date',
  [POST_FIELDS.LIKES]: 'continuous',
  [POST_FIELDS.COMMENTS]: 'continuous',
  [POST_FIELDS.INTERACTIONS]: 'continuous',
  [POST_FIELDS.SHARES]: 'continuous',
  [POST_FIELDS.POLARITY]: 'date',
  [POST_FIELDS.DEVICE]: 'discrete',
  [POST_FIELDS.TAG]: 'discrete',
  [POST_FIELDS.THEME]: 'discrete',
  [POST_FIELDS.GROUP]: 'discrete',
  [POST_FIELDS.VIEWS]: 'continuous',
  [POST_FIELDS.POST_TYPE]: 'discrete',
  [POST_FIELDS.GENDER]: 'discrete',
  [POST_FIELDS.IMPRESSIONS]: 'continuous',
  [POST_FIELDS.REACH]: 'continuous',
  [POST_FIELDS.SAC_TYPE]: 'discrete',
  [POST_FIELDS.SAC_STATUS]: 'discrete',
  [POST_FIELDS.USER_ID]: 'discrete',
  [POST_FIELDS.OPERATOR]: 'discrete',
  [POST_FIELDS.POST_ID]: 'discrete',
  [POST_FIELDS.FB_VIEWS]: 'continuous',
  [POST_FIELDS.ROUTING_ID]: 'discrete',
};

export const USERS_FIELDS_TYPE = {
  [USERS_FIELDS.FOLLOWERS]: 'continuous',
  [USERS_FIELDS.DATE]: 'date',
  [USERS_FIELDS.CHANNEL]: 'discrete',
  [USERS_FIELDS.UID]: 'discrete',
  [USERS_FIELDS.USERNAME]: 'discrete',
};

export const SAC_STATUS_FIELDS_TYPE = {
  [SAC_STATUS_FIELDS.userId]: 'discrete',
  [SAC_STATUS_FIELDS.userName]: 'discrete',
  [SAC_STATUS_FIELDS.pageId]: 'discrete',
  [SAC_STATUS_FIELDS.channel]: 'discrete',
  [SAC_STATUS_FIELDS.status]: 'continuous',
  [SAC_STATUS_FIELDS.lastStatus]: 'discrete',
  [SAC_STATUS_FIELDS.statusChangeTime]: 'continuous',
  [SAC_STATUS_FIELDS.annotateAtDate]: 'date',
};

export const SAC_SURVEYS_FIELDS = {
  userId: 'userId',
  userName: 'username',
  postId: 'pid',
  channel: 'channel',
  surveyScore: 'surveyScore',
  surveyType: 'surveyType',
  surveyDate: 'surveyDate',
};

export const SAC_SURVEYS_FIELDS_TYPE = {
  [SAC_SURVEYS_FIELDS.surveyDate]: 'date',
  [SAC_SURVEYS_FIELDS.channel]: 'discrete',
  [SAC_SURVEYS_FIELDS.surveyScore]: 'discrete',
  [SAC_SURVEYS_FIELDS.userId]: 'discrete',
  [SAC_SURVEYS_FIELDS.userName]: 'discrete',
  [SAC_SURVEYS_FIELDS.postId]: 'discrete',
  [SAC_SURVEYS_FIELDS.userName]: 'discrete',
};

export const FIELDS = {
  posts: POST_FIELDS,
  users: USERS_FIELDS,
  'sac-status': SAC_STATUS_FIELDS,
  'sac-surveys': SAC_SURVEYS_FIELDS,
};

export const TIME_FIELD = {
  posts: POST_FIELDS.POSTED_AT,
  users: USERS_FIELDS.DATE,
  'sac-status': SAC_STATUS_FIELDS.annotateAtDate,
  'sac-surveys': SAC_SURVEYS_FIELDS.surveyDate,
};

export const ENTITIES = {
  POSTS: 'Posts',
  USERS: 'Users',
  SAC_STATUS: 'SacStatus',
  SAC_SURVEYS: 'SacSurveys',
};

export const POINTS_PARSER = {
  POINTS: 'points',
  SERIES: 'series',
  COORDINATES: '',
};

export const VALUE_TYPES = {
  NOMINAL: 'nominal',
  ORDINAL: 'ordinal',
  COUNT: 'count',
  INTERVAL: 'interval',
  TIME: 'time',
};

export const GRANULARITY = {
  MINUTE: {
    label: 'Minuto',
    rule: 180, //3 horas
    datePortion: DATE_PORTION.BY_MINUTE,
    disable: false,
    tooltip: 'Minutos são mostrados no período máximo de 3 horas',
  },
  HOUR: {
    label: 'Hora',
    rule: 4320, //3 dias
    datePortion: DATE_PORTION.BY_HOUR,
    disable: false,
    tooltip: 'Horas são mostradas no período máximo de 3 dias',
  },
  DAY: {
    label: 'Dia',
    rule: 259200, //6 meses
    datePortion: DATE_PORTION.BY_DAY,
    disable: false,
    tooltip: 'Dias são mostrados no período máximo de 180 dias',
  },
  WEEK: {
    label: 'Semana',
    rule: 1814400, //3 anos e 6 meses
    datePortion: DATE_PORTION.BY_WEEK,
    disable: false,
    tooltip: 'Semanas são mostradas no périodo máximo de 3,5 anos',
  },
  MONTH: {
    label: 'Mês',
    rule: 7876800, //15 anos
    datePortion: DATE_PORTION.BY_MONTH,
    disable: false,
  },
  QUARTER: {
    label: 'Trimestre',
    rule: 23328000, //45 anos
    datePortion: DATE_PORTION.BY_QUARTER,
    disable: false,
  },
  AUTO: {
    label: 'Auto',
    rule: 99999999999, //INFINITO
    datePortion: '',
    disable: false,
  },
};
